import React, { useState, useEffect } from "react";

const Vehicles = () => {
  const [vehicles, setVehicles] = useState([
    {
      id: 1,
      licensePlate: "KA-05-AB-1234",
      type: "Feed Truck",
      driver: "Suresh Nair",
      status: "inside",
      entryTime: "06:45",
      exitTime: null,
      duration: "3h 28m",
      purpose: "Feed delivery",
      authorized: true,
      confidence: 99,
      lastSeen: "Just now",
    },
    {
      id: 2,
      licensePlate: "KA-02-CD-5678",
      type: "Harvesting Truck",
      driver: "Arjun Singh",
      status: "outside",
      entryTime: "12:15",
      exitTime: "13:45",
      duration: "1h 30m",
      purpose: "Harvest transport",
      authorized: true,
      confidence: 98,
      lastSeen: "1h 18m ago",
    },
    {
      id: 3,
      licensePlate: "TN-08-EF-9012",
      type: "Maintenance Van",
      driver: "Unknown",
      status: "inside",
      entryTime: "14:10",
      exitTime: null,
      duration: "23m",
      purpose: "Equipment repair",
      authorized: false,
      confidence: 87,
      lastSeen: "2m ago",
      flag: "unauthorized",
    },
    {
      id: 4,
      licensePlate: "KA-12-GH-3456",
      type: "Supply Vehicle",
      driver: "Ravi Kumar",
      status: "outside",
      entryTime: "10:30",
      exitTime: "11:45",
      duration: "1h 15m",
      purpose: "Supply delivery",
      authorized: true,
      confidence: 96,
      lastSeen: "3h 18m ago",
    },
    {
      id: 5,
      licensePlate: "KA-15-IJ-7890",
      type: "Staff Transport",
      driver: "Mohan Rao",
      status: "inside",
      entryTime: "06:00",
      exitTime: null,
      duration: "8h 13m",
      purpose: "Staff transport",
      authorized: true,
      confidence: 99,
      lastSeen: "4m ago",
    },
  ]);

  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [recentEvents, setRecentEvents] = useState([
    {
      id: 1,
      timestamp: "14:32:15",
      licensePlate: "KA-05-AB-1234",
      event: "entry",
      type: "Feed Truck",
      driver: "Suresh Nair",
      confidence: 99,
    },
    {
      id: 2,
      timestamp: "14:10:42",
      licensePlate: "TN-08-EF-9012",
      event: "entry",
      type: "Maintenance Van",
      driver: "Unknown",
      confidence: 87,
      flag: "unauthorized",
    },
    {
      id: 3,
      timestamp: "13:45:03",
      licensePlate: "KA-02-CD-5678",
      event: "exit",
      type: "Harvesting Truck",
      driver: "Arjun Singh",
      confidence: 98,
    },
    {
      id: 4,
      timestamp: "12:15:18",
      licensePlate: "KA-02-CD-5678",
      event: "entry",
      type: "Harvesting Truck",
      driver: "Arjun Singh",
      confidence: 99,
    },
    {
      id: 5,
      timestamp: "11:45:09",
      licensePlate: "KA-12-GH-3456",
      event: "exit",
      type: "Supply Vehicle",
      driver: "Ravi Kumar",
      confidence: 96,
    },
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setVehicles((prev) =>
        prev.map((vehicle) => {
          if (vehicle.status === "inside") {
            const durationParts = vehicle.duration.split("h ");
            const hours = parseInt(durationParts[0]);
            const minutes = parseInt(durationParts[1]);
            const newMinutes = minutes + 1;

            return {
              ...vehicle,
              duration:
                newMinutes < 60
                  ? `${hours}h ${newMinutes}m`
                  : `${hours + 1}h ${newMinutes - 60}m`,
              lastSeen: "Just now",
            };
          }
          return vehicle;
        })
      );
      setLastUpdate(new Date());
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const insideCount = vehicles.filter((v) => v.status === "inside").length;
  const outsideCount = vehicles.filter((v) => v.status === "outside").length;
  const unauthorizedCount = vehicles.filter((v) => !v.authorized).length;

  const getStatusColor = (status, authorized) => {
    if (!authorized) {
      return "bg-red-50 border-red-200 text-red-900";
    }
    switch (status) {
      case "inside":
        return "bg-emerald-50 border-emerald-200 text-emerald-900";
      case "outside":
        return "bg-gray-50 border-gray-200 text-gray-900";
      default:
        return "bg-gray-50 border-gray-200 text-gray-900";
    }
  };

  const getStatusBadge = (status, authorized) => {
    if (!authorized) {
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-700 text-xs font-medium rounded">
          ⚠ Unauthorized
        </span>
      );
    }
    switch (status) {
      case "inside":
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-emerald-100 text-emerald-700 text-xs font-medium rounded">
            ● Inside
          </span>
        );
      case "outside":
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded">
            ○ Outside
          </span>
        );
      default:
        return null;
    }
  };

  const getEventBadge = (event, flag) => {
    if (flag === "unauthorized") {
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-700 text-xs font-medium rounded">
          ⚠ Unauthorized
        </span>
      );
    }
    switch (event) {
      case "entry":
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded">
            ↓ Entry
          </span>
        );
      case "exit":
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-700 text-xs font-medium rounded">
            ↑ Exit
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-6 py-5 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Vehicle Monitoring</h2>
        <p className="text-sm text-gray-500 mt-1">
          Real-time tracking of vehicle movements across the facility
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 px-6 py-5 bg-gray-50 border-b border-gray-200">
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Inside
          </span>
          <span className="text-2xl font-bold text-emerald-600 mt-1">
            {insideCount}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Outside
          </span>
          <span className="text-2xl font-bold text-gray-600 mt-1">
            {outsideCount}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Total
          </span>
          <span className="text-2xl font-bold text-blue-600 mt-1">
            {vehicles.length}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Unauthorized
          </span>
          <span className="text-2xl font-bold text-red-600 mt-1">
            {unauthorizedCount}
          </span>
        </div>
      </div>

      <div className="px-6 py-5 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900 mb-4">Current Vehicles</h3>
        <div className="space-y-3">
          {vehicles.map((vehicle) => (
            <div
              key={vehicle.id}
              onClick={() =>
                setSelectedVehicle(
                  selectedVehicle?.id === vehicle.id ? null : vehicle
                )
              }
              className={`border rounded-lg p-4 cursor-pointer transition-all ${getStatusColor(
                vehicle.status,
                vehicle.authorized
              )} ${
                selectedVehicle?.id === vehicle.id
                  ? "ring-2 ring-offset-0 ring-blue-400"
                  : "hover:shadow-md"
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="font-semibold text-sm">{vehicle.licensePlate}</h3>
                  <p className="text-xs opacity-75 mt-1">{vehicle.type}</p>
                </div>
                {getStatusBadge(vehicle.status, vehicle.authorized)}
              </div>

              <div className="space-y-2 text-sm">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Driver</span>
                  <span className="font-semibold text-xs">
                    {vehicle.driver}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Purpose</span>
                  <span className="font-semibold text-xs">{vehicle.purpose}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Duration</span>
                  <span className="font-mono font-semibold text-xs">
                    {vehicle.duration}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Confidence</span>
                  <span className="font-mono font-semibold text-xs">
                    {vehicle.confidence}%
                  </span>
                </div>
              </div>

              {selectedVehicle?.id === vehicle.id && (
                <div className="mt-4 pt-4 border-t border-current border-opacity-20 space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-700">Entry Time</span>
                    <span className="font-mono text-xs">{vehicle.entryTime}</span>
                  </div>
                  {vehicle.exitTime && (
                    <div className="flex justify-between">
                      <span className="text-gray-700">Exit Time</span>
                      <span className="font-mono text-xs">
                        {vehicle.exitTime}
                      </span>
                    </div>
                  )}
                  <div className="flex justify-between">
                    <span className="text-gray-700">Last Seen</span>
                    <span className="font-semibold text-xs">
                      {vehicle.lastSeen}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-700">Detection</span>
                    <span className="font-semibold text-xs">
                      License plate detected
                    </span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="px-6 py-5">
        <h3 className="text-sm font-semibold text-gray-900 mb-4">Recent Events</h3>
        <div className="space-y-3">
          {recentEvents.map((event) => (
            <div
              key={event.id}
              className={`border rounded-lg p-4 transition-all ${
                event.flag === "unauthorized"
                  ? "bg-red-50 border-red-200 text-red-900"
                  : "bg-gray-50 border-gray-200 text-gray-900"
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <p className="font-semibold text-sm">
                    {event.licensePlate}
                  </p>
                  <p className="text-xs opacity-75 mt-1">{event.timestamp}</p>
                </div>
                {getEventBadge(event.event, event.flag)}
              </div>

              <div className="space-y-2 text-sm">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Vehicle</span>
                  <span className="font-semibold text-xs">{event.type}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Driver</span>
                  <span className="font-semibold text-xs">{event.driver}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Confidence</span>
                  <span className="font-mono font-semibold text-xs">
                    {event.confidence}%
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 text-xs text-gray-500">
        Last updated: {lastUpdate.toLocaleTimeString()} • Detection confidence: 98%
      </div>
    </div>
  );
};

export default Vehicles;